import crypto from 'crypto'
import config from '../config'

export default {
    descriptografar(senha) {
        const decipher = crypto.createDecipher(config.DADOS_CRIPTOGRAFAR.algoritmo, config.DADOS_CRIPTOGRAFAR.segredo);
        decipher.update(senha, config.DADOS_CRIPTOGRAFAR.tipo);
        return (decipher.final()).toString();
    }
}



// WEBPACK FOOTER //
// ./src/services/decrypt.js